import Vue from 'vue';
// Vue Resource
import VueResource from 'vue-resource';

Vue.use(VueResource);
Vue.http.options.root = `${window.location.protocol}//${window.location.host}/admin/v1`

// Axios
// import axios    from 'axios';
// import VueAxios from 'vue-axios';

// axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// Vue.use(VueAxios, axios);

export default {
  root: Vue.http.options.root
};
